import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import { useGetCategorySeoCSV } from '@/hooks/useGetCategorySeoCSV';

export function DownloadButton() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.SeoContent.components.DownloadButton',
  });
  const { categorySeoCSV, getCategorySeoCSV, isLoading } =
    useGetCategorySeoCSV();

  async function handleDownload() {
    try {
      let url = categorySeoCSV?.url;

      if (!categorySeoCSV) {
        const { data } = await getCategorySeoCSV();
        url = data?.url;
      }

      if (url) {
        window.open(url);
      }
    } catch {
      toast.error(t('downloadError'));
    }
  }

  return (
    <div className="flex items-center justify-end">
      <Button disabled={isLoading} onClick={handleDownload}>
        {isLoading ? (
          <>
            <Loader2 className="animate-spin" /> {t('downloadingLabel')}
          </>
        ) : (
          t('downloadLabelGenerate')
        )}
      </Button>
    </div>
  );
}
